'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface PNRSearchBarProps {
  onSearch: (pnr: string) => void;
}

const PNRSearchBar = ({ onSearch }: PNRSearchBarProps) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchValue.trim()) {
      onSearch(searchValue.trim());
    }
  };

  if (!isHydrated) {
    return (
      <div className="bg-card rounded-lg shadow-brand p-6 border border-border">
        <div className="animate-pulse h-12 bg-muted rounded"></div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg shadow-brand p-6 border border-border">
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1 relative">
          <Icon 
            name="MagnifyingGlassIcon" 
            size={20} 
            className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground"
          />
          <input
            type="text"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="Enter PNR or Booking Reference"
            className="w-full pl-12 pr-4 py-3 bg-surface border border-input rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent transition-all duration-200"
          />
        </div>
        <button
          type="submit"
          className="px-6 py-3 bg-primary text-primary-foreground font-heading font-semibold rounded-lg hover:bg-secondary transition-all duration-300 shadow-sm hover:shadow-md flex items-center justify-center space-x-2"
        >
          <Icon name="MagnifyingGlassIcon" size={20} />
          <span>Check Status</span>
        </button>
      </form>
      <p className="text-xs text-muted-foreground mt-3">
        Enter your 6-character PNR or booking reference to view real-time status
      </p>
    </div>
  );
};

export default PNRSearchBar;